import { CollectionGridBlock } from './collection-grid.block'
import { CollectionGridComponent } from './collection-grid.component'
import { useCollectionOffersQuery } from './queries'

export const CollectionGridContainer = (block: CollectionGridBlock) => {
  const { data } = useCollectionOffersQuery({
    collectionId: block.collection.id,
    limit: block.limit,
  })

  return <CollectionGridComponent {...block} offers={data?.Offers?.docs || []} />
}
